import { AchievementId } from '../types/Achievement';

export interface AchievementMeta {
  name: string;
  description: string;
}

export const ACHIEVEMENT_META: Record<AchievementId, AchievementMeta> = {
  [AchievementId.CAMPAIGN_ALL_STAGES]: {
    name: '伝説の導き手',
    description: 'キャンペーン全9ステージをクリアした',
  },
  [AchievementId.CAMPAIGN_ALL_MONSTERS]: {
    name: '八魂の覇者',
    description: '全8キャラクターでボスを撃破した',
  },

  [AchievementId.TOURNAMENT_ELIMINATION_CHAMPION_LV1]: {
    name: '見習い王者',
    description: 'トーナメントでAI Lv1以上を相手に優勝した',
  },
  [AchievementId.TOURNAMENT_ELIMINATION_CHAMPION_LV2]: {
    name: '初級王者',
    description: 'トーナメントでAI Lv2以上を相手に優勝した',
  },
  [AchievementId.TOURNAMENT_ELIMINATION_CHAMPION_LV3]: {
    name: '中級王者',
    description: 'トーナメントでAI Lv3以上を相手に優勝した',
  },
  [AchievementId.TOURNAMENT_ELIMINATION_CHAMPION_LV4]: {
    name: '上級王者',
    description: 'トーナメントでAI Lv4以上を相手に優勝した',
  },
  [AchievementId.TOURNAMENT_ELIMINATION_CHAMPION_LV5]: {
    name: '熟練王者',
    description: 'トーナメントでAI Lv5以上を相手に優勝した',
  },
  [AchievementId.TOURNAMENT_ELIMINATION_CHAMPION_LV6]: {
    name: '達人王者',
    description: 'トーナメントでAI Lv6を相手に優勝した',
  },
  [AchievementId.TOURNAMENT_ROUND_ROBIN_CHAMPION_LV1]: {
    name: '見習い覇者',
    description: '総当たりでAI Lv1以上を相手に優勝した',
  },
  [AchievementId.TOURNAMENT_ROUND_ROBIN_CHAMPION_LV2]: {
    name: '初級覇者',
    description: '総当たりでAI Lv2以上を相手に優勝した',
  },
  [AchievementId.TOURNAMENT_ROUND_ROBIN_CHAMPION_LV3]: {
    name: '中級覇者',
    description: '総当たりでAI Lv3以上を相手に優勝した',
  },
  [AchievementId.TOURNAMENT_ROUND_ROBIN_CHAMPION_LV4]: {
    name: '上級覇者',
    description: '総当たりでAI Lv4以上を相手に優勝した',
  },
  [AchievementId.TOURNAMENT_ROUND_ROBIN_CHAMPION_LV5]: {
    name: '熟練覇者',
    description: '総当たりでAI Lv5以上を相手に優勝した',
  },
  [AchievementId.TOURNAMENT_ROUND_ROBIN_CHAMPION_LV6]: {
    name: '達人覇者',
    description: '総当たりでAI Lv6を相手に優勝した',
  },

  [AchievementId.SURVIVAL_WIN_10]: {
    name: '10連勝',
    description: 'サバイバルで10連勝を達成した',
  },
  [AchievementId.SURVIVAL_WIN_20]: {
    name: '20連勝',
    description: 'サバイバルで20連勝を達成した',
  },
  [AchievementId.SURVIVAL_WIN_30]: {
    name: '30連勝',
    description: 'サバイバルで30連勝を達成した',
  },
  [AchievementId.SURVIVAL_WIN_40]: {
    name: '40連勝',
    description: 'サバイバルで40連勝を達成した',
  },
  [AchievementId.SURVIVAL_WIN_50]: {
    name: '50連勝',
    description: 'サバイバルで50連勝を達成した',
  },
  [AchievementId.SURVIVAL_WIN_60]: {
    name: '60連勝',
    description: 'サバイバルで60連勝を達成した',
  },
  [AchievementId.SURVIVAL_WIN_70]: {
    name: '70連勝',
    description: 'サバイバルで70連勝を達成した',
  },
  [AchievementId.SURVIVAL_WIN_80]: {
    name: '80連勝',
    description: 'サバイバルで80連勝を達成した',
  },
  [AchievementId.SURVIVAL_WIN_90]: {
    name: '90連勝',
    description: 'サバイバルで90連勝を達成した',
  },
  [AchievementId.SURVIVAL_WIN_100]: {
    name: '100連勝',
    description: 'サバイバルで100連勝を達成した',
  },
  [AchievementId.UNLOCK_ALICE]: {
    name: '傀儡少女の覚醒',
    description: '謎の挑戦者アリスを打ち破り、仲間に加えた',
  },
  [AchievementId.UNLOCK_MOCOCO]: {
    name: '夢幻の友',
    description: '謎のマスコットを打ち破り、仲間に加えた',
  },
};
